<template>
  <div>
    <b-row>
      <!-- Columna Izquierda -->
      <b-card-group class="col-md-4">
        <b-col>
          <InformacionCita :tokenCita="tokenCita" />

          <InfoSignosVitales v-if="idPaciente" :idPaciente="idPaciente" :idCitaActual="dataCita.id" />

          <HistorialAtenciones v-if="idPaciente" :idPaciente="idPaciente" />

          <HistorialImagenesLabs :idPaciente="idPaciente" />

          <HistorialDerivacionesInterconsultas v-if="idPaciente" :idPaciente="idPaciente" />
        </b-col>
      </b-card-group>

      <b-card-group class="col-md-8">
        <b-col>
          <CrearAnamnesis :idPaciente="idPaciente" />

          <CrearReceta />

          <AtencionImagenes />

          <AtencionLaboratorios />

          <AtencionTerapias />

          <AtencionProcesos />

          <CrearDescansoMedico />

          <AtencionDocAs400 v-if="esCoberturaIESS" />

          <crear-encuesta @token-enviado="recibirTokenEncuesta" v-bind:tokenaleatorio="tokenaleatorio" />

          <b-row>
            <b-col md="12">
              <b-card no-body :class="{ open: visibleTarjetaAmarilla }">
                <b-card-header style="
                    background-color: #0080c9;
                    color: white;
                    font: 45px;
                    padding: 1rem;
                  " :class="{ collapsed: !visibleTarjetaAmarilla }" data-toggle="collapse" @click="
                    () => (visibleTarjetaAmarilla = !visibleTarjetaAmarilla)
                  ">
                  <span class="lead collapse-title"><strong>TARJETA AMARILLA</strong></span>
                  <i :class="visibleTarjetaAmarilla
                      ? 'fas fa-chevron-up'
                      : 'fas fa-chevron-down'
                    " />
                </b-card-header>
                <b-collapse v-model="visibleTarjetaAmarilla" :accordion="accordion" role="tabpanel">
                  <b-card-body style="padding: 10px">
                    <CrearTarjetaAmarilla />
                  </b-card-body>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col>
              <DerivacionesInterconsultas />
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col class="d-flex align-items-center justify-content-start">
              <b-button variant="info" class="py-1" @click="onShowModalSignature">
                <i class="fa-solid fa-pen-clip mr-1" />
                Firma del Paciente
              </b-button>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col class="d-flex align-items-center justify-content-end">
              <b-button variant="success" @click="onSubmitAtencionMedica" :disabled="clickoCrearAtencion">
                Finalizar Atencion Medica
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-card-group>
    </b-row>

    <b-modal v-model="showModalDerivaciones" hide-footer size="lg">
      <h2 class="text-center">Procesos pendientes de la atencion medica</h2>

      <b-card class="mb-0 mt-2" style="border: 1px solid #c9c9c9">
        <div v-for="derivacion in derivacionesRegistradas" :key="derivacion.id"
          class="d-flex align-items-center justify-content-between my-1 px-2">
          <h6>Derivacion {{ derivacion.especialidad }}</h6>
          <b-button variant="success" @click="onRedirectToDerivacion(derivacion.token)">
            Completar
          </b-button>
        </div>

        <hr />

        <div v-for="interconsulta in interconsultasRegistradas" :key="interconsulta.id"
          class="d-flex align-items-center justify-content-between my-1 px-2">
          <h6>Interconsulta {{ interconsulta.especialidad }}</h6>
          <b-button variant="success" @click="onRedirectToInterconsulta(interconsulta.token)">
            Completar
          </b-button>
        </div>
      </b-card>

      <div class="my-1 mb-1 d-flex align-items-center justify-content-end">
        <b-button class="d-flex" @click="onCompletarDespues">
          Completar despues
        </b-button>
      </div>
    </b-modal>

    <!-- <AlertReloadPage/> -->

    <TopazSignature :isVisible.sync="openModalSignature" />
  </div>
</template>

<script>
import rutas from "@/assets/utils/rutas.json";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { BootstrapVue } from "bootstrap-vue";
import { mapState } from "vuex";
import {
  calculateAgeWithDateString,
  getCurrentDate,
  getEstablecimientoLS,
} from "@/shared/helpers";
import TopazSignature from "@/views/topaz/TopazSignature.vue";

import {
  interconsultaService,
  derivacionesService,
} from "@/views/derivaciones/services";
import { recetaService } from "@/views/farmacia/services";
import CrearTarjetaAmarilla from "@/views/citas/CrearTarjetaAmarilla.vue";
import {
  InfoSignosVitales,
  InformacionCita,
  CrearAnamnesis,
  AtencionDocAs400,
  CrearEncuesta,
  CrearDescansoMedico,
  AtencionProcesos,
  AtencionImagenes,
  AtencionTerapias,
  HistorialAtenciones,
  CrearReceta,
  HistorialImagenesLabs,
  HistorialDerivacionesInterconsultas,
  AtencionLaboratorios,
  DerivacionesInterconsultas,
} from "@/views/atencionCita/components";

import {
  anamnesisService,
  diagnosticosService,
} from "@/views/atencionMedica/services";
import { imagenesService } from "@/views/imagen/services";
import { terapiasService } from "@/views/terapia/services";
import { procedimientosService } from "@/views/procesoclinico/services";
import { fileService } from "@/shared/services";
import {
  registerExamenes,
  deleteRespaldoAtencion,
  loadRespaldo,
  clearDataAtencion,
} from "@/views/atencionCita/helpers";
import { descansoMedicoService, ginecologiaService } from "../services";
import { labAuxiliarService } from "../../laboratorio/services";

export default {
  components: {
    ...BootstrapVue.components,
    InfoSignosVitales,
    InformacionCita,
    CrearDescansoMedico,
    CrearReceta,
    CrearAnamnesis,
    CrearTarjetaAmarilla,
    AtencionDocAs400,
    AtencionProcesos,
    AtencionTerapias,
    CrearEncuesta,

    DerivacionesInterconsultas,

    HistorialAtenciones,
    HistorialImagenesLabs,
    HistorialDerivacionesInterconsultas,

    TopazSignature,
    AtencionLaboratorios,
    AtencionImagenes,
  },

  data() {
    return {
      odontograma_id: null,
      identificador: null,

      clickoCrearAtencion: false,

      derivar: false,
      dataCita: null,
      fechasCitas: null,
      esDerivacion: null,
      isInterconsulta: false,

      showModalDerivaciones: false,
      derivacionesRegistradas: [],
      interconsultasRegistradas: [],

      tokenAtencion: null,

      doc: null,
      cacm: null,

      especialidadcita: null,
      nivelEducacion: "",
      idPaciente: "",
      consultamedicaid: "",

      encuesta: "",
      observaciones: "",
      tokenEncuestaAM: "",
      tokenaleatorio: "",

      visible: false,
      visibleTarjetaAmarilla: false,
      visibleEncuesta: false,

      idcita: "",
      tokenCita: null,
      textoCopy: null,

      options: {},

      itemCita: null,
      dataTerapia: null,
      codEsp: null,
      encuestarealizada: false,

      documento: null,

      enc: false,

      processList: [],
      openModalSignature: false,
    };
  },

  async created() {
    this.loadDataRespaldo();

    window.addEventListener("beforeunload", this.handleBeforeUnload);
    clearDataAtencion();

    this.doc = false;
    this.enc = false;
    localStorage.setItem("doc", this.doc);
    localStorage.setItem("enc", this.enc);
    localStorage.removeItem("idPaciente");
    this.tokenaleatorio = uuidv4();

    this.comprobarPermisos();
    this.setToken();

    const id = this.$route.params.id; // Obtén el ID de la ruta
    this.idcita = id;
    await this.fetchGetCita(id);
    this.loadDataInit();
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },

  computed: {
    accordion() {
      return this.$parent.accordion
        ? `accordion-${this.$parent.collapseID}`
        : null;
    },

    ...mapState({
      stAtencionCita: (state) => state.atencionCita,
      stAnamnesis: (state) => state.atencionCita.anamnesis,
      stDataCita: (state) => state.atencionCita.dataCita,
      stEspDoctor: (state) =>
        state.atencionCita.dataCita?.doctor.especialidad.codEsp,
      stDataSemiologia: (state) => state.atencionCita.semiologias?.semActual,
      stSignature: (state) => state.atencionCita.pacienteSignature,
      stEncuesta: (state) => state.atencionCita.encuesta,
      stDocAs400: (state) => state.atencionCita.docAs400,

      stAtencionLaboratoriosAs400: (state) =>
        state.atencionCita.laboratorios.laboratoriosAs400,
      stAtencionLaboratoriosAux: (state) =>
        state.atencionCita.laboratorios.laboratoriosAux,
    }),

    esCoberturaIESS() {
      return this.stDataCita?.cobSeleccionada.id === "1";
    },
  },

  methods: {
    loadDataRespaldo() {
      this.idCita = this.$route.params.id;
      this.identificador = this.idCita;
    },

    onShowModalSignature() {
      this.openModalSignature = true;
    },

    async loadDataInit() {
      const historialRecetas = await recetaService.getAllByPaciente(
        this.idPaciente
      );
      this.$store.commit("setHistorialRecetas", historialRecetas);

      const recetasToday = historialRecetas.filter((receta) => {
        const fechaCreacion = new Date(receta.fechaCreacion);
        const ahora = new Date();
        const horasDiferencia = (ahora - fechaCreacion) / (1000 * 60 * 60); // Convertimos la diferencia a horas
        return horasDiferencia < 24;
      });

      if (!recetasToday.length) return;

      const medicamentosToday = recetasToday.flatMap((receta) =>
        receta.medicamentosRecetados.map((m) => m.medicamento)
      );
      this.$store.commit("setMedicamentosSendToday", medicamentosToday);
    },

    handleBeforeUnload(event) {
      const message = "¿Estás seguro de que deseas recargar esta página?";
      event.returnValue = message; // Esto muestra la alerta en algunos navegadores
      return message; // Retornar el mensaje para navegadores que lo requieren
    },

    recibirTokenEncuesta(token) {
      this.tokenEncuestaAM = token;
    },

    setToken() {
      const user = JSON.parse(localStorage.getItem("usuario"));
      this.login_user = user.username;
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`; // for all requests
    },

    async onRegisterGinecologia() {
      const dataGinecoLS = loadRespaldo(
        this.idcita,
        "antecedentesGinecologicos"
      );
      if (!dataGinecoLS) return;

      const dataGineco = JSON.stringify(dataGinecoLS);
      const responseGineco = await ginecologiaService.registerAntecedentes(
        this.tokenAtencion,
        dataGineco
      );
    },

    async onRegisterAnamnesis() {
      let dataAnamnesisLS =
        JSON.parse(localStorage.getItem("crearAnamnesis")) || null;

      const last_odontograma_inicial = await anamnesisService.lastOdontogramaInicial(this.stDataCita.paciente.id)
      this.odontograma_id = last_odontograma_inicial?.id
      if (
        this.stDataSemiologia &&
        this.stDataSemiologia.tipo === "odontologica"
      ) {
        const odontograma_nuevo = await anamnesisService.saveOdontogramaInicial(
          this.idcita,
          this.stDataSemiologia
        );
        if (odontograma_nuevo) {
          this.odontograma_id = odontograma_nuevo?.id;
        }
      }
      if (this.odontograma_id) {
        dataAnamnesisLS.semiologia = {
          ...dataAnamnesisLS.semiologia,
          odontograma_id: this.odontograma_id,
        };
      }
      const responseAnamnesis = await anamnesisService.register(
        this.cacm,
        this.idcita,
        dataAnamnesisLS
      );
      this.processList.push({
        text: "Anamnesis registrada",
        value: responseAnamnesis,
      });
    },

    async putAtencionInEncuesta() {
      const tokenEncuesta = this.stEncuesta?.data?.token;
      const idAtencion = this.cacm;

      const query = `
        mutation PutIdAtencionInEncuesta(
          $tokenEncuesta: String!
          $idAtencion: String! 
        ) {
          PutIdAtencionInEncuesta(
            tokenEncuesta: $tokenEncuesta, 
            idAtencion: $idAtencion
          ) {
            message
            status
            encuesta {
              id
              token
              calificacion
              observaciones
            }
          }
        }
      `;

      const variables = {
        tokenEncuesta: tokenEncuesta,
        idAtencion: idAtencion,
      };

      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables,
        });
      } catch (error) {
        console.error("ERROR AL ACTUALIZAR LA ENCUESTA:", error);
      }
    },

    async onRegisterDiagnosticos() {
      const dataDiagnosticosLS = loadRespaldo(this.idcita, "diagnosticos");

      const diagnosticosToCreate = dataDiagnosticosLS.map((d) => ({
        atencionMedica: this.cacm,
        diagnostico: d.diagnostico.value,
        tipoDiagnostico: d.tipo.value,
        esPrincipal: d.principal ? "1" : "0",
      }));

      const diagnosticosToProcess = {
        diagnosticosToCreate: diagnosticosToCreate,
      };

      const responseDiagnosticos = await diagnosticosService.multipleProcesos(
        diagnosticosToProcess
      );
      this.processList.push({
        text: "Diagnosticos Registrados",
        value: responseDiagnosticos,
      });
    },

    async onRegisterReceta() {
      const dataRecetaLS =
        JSON.parse(localStorage.getItem("atencionReceta")) || [];
      if (!dataRecetaLS.length) return;
      const alergias = localStorage.getItem("alergias");
      const responseReceta = await recetaService.register(
        this.cacm,
        dataRecetaLS,
        alergias
      );
      this.processList.push({ text: "Receta creada", value: responseReceta });
    },

    async onRegisterImagenes() {
      const dataImagenesLS = loadRespaldo(this.identificador, "imagenes") || [];

      if (!dataImagenesLS.length) return;

      const mergeNumeroPieza = (texto = "", numeroPieza) => {
        const base = (texto || "").replace(/,?\s*Numero de Pieza:.*$/i, "").trim();
        const numero = (numeroPieza ?? "").toString().trim();
        if (!numero) return base;
        const sep = base ? ", " : "";
        return `${base}${sep}Numero de Pieza: ${numero}`;
      };

      const imagenesMap = dataImagenesLS.map((d) => ({
        action: d.action,
        diagnostico: d.diagnostico || null,
        imagenId: d.imagen?.value,
        numeroOrden: d.numeroOrden,
        lateralidad: d.lateralidad.value,
        numeroPieza: d.numeroPieza,
        motivoSolicitud: mergeNumeroPieza(d.motivoSolicitud, d.numeroPieza),
        resumenClinico: mergeNumeroPieza(d.resumenClinico, d.numeroPieza),
        sedacion: d.sedacion,
        justificacion: d.justificacion,
        idRegistro: d?.idRegistro,
      }));

      const responseImagenes = await imagenesService.processEnvios(
        this.tokenAtencion,
        imagenesMap
      );
      this.processList.push({
        text: "Imagenes creadas",
        value: responseImagenes,
      });
    },

    async onRegisterExamenes() {
      let responseLab = null;

      if (this.stAtencionLaboratoriosAs400?.final.length) {
        const registerAs400 = await registerExamenes(
          this.tokenAtencion,
          this.stAtencionLaboratoriosAs400
        );
        responseLab = registerAs400;
      }

      // registrar auxiliares
      if (this.stAtencionLaboratoriosAux?.length) {
        const dataLabMapped = this.stAtencionLaboratoriosAux.map((d) => {
          const { estadoLaboratorio, ...rest } = d; // excluimos estadoLaboratorio

          return {
            ...rest,
            atencionMedica: this.tokenAtencion,
            laboratorios: JSON.stringify(d.laboratorios),
          };
        });

        const registerAuxiliares = await labAuxiliarService.saveLaboratorios(
          dataLabMapped
        );
        responseLab = registerAuxiliares;
      }

      if (!responseLab) return;
      this.processList.push({
        text: "Examenes Registrados",
        value: responseLab,
      });
    },

    async onRegisterTerapias() {
      const dataTerapiasLS = loadRespaldo(this.identificador, "terapias") || [];

      if (!dataTerapiasLS.length) return;

      const terapiasMap = dataTerapiasLS.map((d) => ({
        action: d.action,
        terapiaId: d.terapia?.value,
        numeroOrden: d.numeroOrden,
        cantidad: d.cantidad,
        motivoSolicitud: d.motivoSolicitud,
        resumenClinico: d.resumenClinico,
        idRegistro: d?.idRegistro,
      }));

      const responseTerapias = await terapiasService.processEnvios(
        this.tokenAtencion,
        terapiasMap
      );
      this.processList.push({
        text: "Terapias Registradas",
        value: responseTerapias,
      });
    },

    async onRegisterProcesosClinicos() {
      const dataEnvioProcedimientos =
        loadRespaldo(this.identificador, "procesos") || [];
      if (!dataEnvioProcedimientos.length) return;


      const envioProcedimientosMap = dataEnvioProcedimientos.map((d) => {
        const isOdonto = d.odonto || !!d.procedimiento_odonto;
        const procedimientoSeleccionado = d.procedimiento || d.procedimiento_odonto;

        return {
          action          : d.action,
          procedimientoId : !isOdonto ? procedimientoSeleccionado?.value : null,
          procOdontoId    :  isOdonto ? procedimientoSeleccionado?.value : null,
          numeroOrden     : d.numeroOrden,
          motivoSolicitud : d.motivoSolicitud,
          resumenClinico  : d.resumenClinico,
          justificacion   : d.justificacion,
        };
      });

      // const envioProcedimientosMap = dataEnvioProcedimientos.map((d) => ({
      //   action: d.action,
      //   procedimientoId: d.procedimiento?.value,
      //   procOdontoId: d.procedimiento_odonto?.value,
      //   numeroOrden: d.numeroOrden,
      //   motivoSolicitud: d.motivoSolicitud,
      //   resumenClinico: d.resumenClinico,
      //   justificacion: d.justificacion,
      // }));

      const responseSave = await procedimientosService.processEnvios(
        this.tokenAtencion,
        envioProcedimientosMap
      );

      this.processList.push({
        text: "Procedimientos Guardados",
        value: responseSave,
      });
    },

    async onRegisterDescansoMedico() {
      const dataDescansosLS =
        JSON.parse(localStorage.getItem("descanso")) || [];
      if (!dataDescansosLS.length) return;
      const responseDescansos = await descansoMedicoService.register(
        this.cacm,
        dataDescansosLS
      );
      this.processList.push({
        text: "Descanso creado",
        value: responseDescansos,
      });
    },

    async onRegisterDocumentoAS400() {
      const newDocAs400 = this.stDocAs400.newFile;

      if (!newDocAs400) {
        console.error("No hay newDocAs400");
        return null;
      }

      const urlDocAs400 = await fileService.upload(
        "docAs400",
        newDocAs400,
        this.paciente
      );

      if (!urlDocAs400) return null;

      const query = `
        mutation crearDocCita(
          $urlDoc: String!,
          $cita  : String!,
        ){ 
          crearDocCita(
            urlDoc: $urlDoc
            cita  : $cita
          ){
            doccita {
              token,id
            }
            status,
            message
          }
        } 
      `;

      const variables = {
        urlDoc: urlDocAs400,
        cita: this.idcita,
      };

      let data = null;

      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables,
        });
        if (response.status !== 200) return null;

        const response2 = response.data.data.crearDocCita;
        if (response2.status !== "success") return null;

        data = response2.doccita;
        localStorage.removeItem("doccitamedica");
      } catch (err) {
        console.error("Error al registrar documento AS400:", err);
      }

      this.processList.push({ text: "Documento creado", value: data });
    },

    async onSubmitAtencionMedica() {
      this.clickoCrearAtencion = true;

      const isValidDataAtencion = this.validateDataAtencion();
      if (!isValidDataAtencion) {
        this.clickoCrearAtencion = false;
        return;
      }

      const responseCreate = await this.crearConsultaCitaMedica();

      if (!responseCreate) {
        this.clickoCrearAtencion = false;
        console.error(
          "Clicko mas de una vez y por tanto se bloqueo una generacion de una atencion duplicada"
        );
      } else {
        await this.putAtencionInEncuesta();
        await this.onRegisterAnamnesis();
        await this.onRegisterGinecologia();
        await this.onRegisterDiagnosticos();
        await this.onRegisterReceta();
        await this.onRegisterImagenes();
        await this.onRegisterExamenes();
        await this.onRegisterTerapias();
        await this.onRegisterProcesosClinicos();
        await this.onRegisterDescansoMedico();

        if (this.esCoberturaIESS) await this.onRegisterDocumentoAS400();

        this.ingresarDerivaciones();
        this.ingresarInterconsultas();
        this.ingresarInterconsultasB();

        console.log("los procesos", this.processList);
      }

      await this.$swal({
        title: "Exito",
        text: "Guardado",
        icon: "success",
        confirmButtonText: "Entendido",
      });

      await deleteRespaldoAtencion(this.identificador);
      await clearDataAtencion();

      if (!this.showModalDerivaciones) {
        this.clickoCrearAtencion = false;
        this.$router.push({ name: "consultar_citas" });
      }

      this.clickoCrearAtencion = false;
    },

    validateDataAtencion() {
      const diagnosticosRespaldo = loadRespaldo(this.idcita, "diagnosticos");
      const hasDiagnosticoPrincipal = diagnosticosRespaldo?.find(
        (d) => d.principal
      );

      const dataAnamnesisLS = localStorage.getItem("crearAnamnesis");
      const dataAnamnesisObj = dataAnamnesisLS && JSON.parse(dataAnamnesisLS);
      const hasMotivoConsulta = dataAnamnesisObj?.motivoConsulta;

      const encuestaRealizada = this.stEncuesta.subido;
      const documentoAs400 = this.stDocAs400.newFile;

      let errors = [];

      if (this.stEspDoctor === "0000000522" && !this.stDataSemiologia)
        errors.push("Debe llenar la evaluacion psicologica");

      if (!hasMotivoConsulta)
        errors.push("Debe ingresar el motivo de la consulta");

      if (!this.stAnamnesis.ocurrencia)
        errors.push("Debe ingresar la ocurrencia");

      if (!hasDiagnosticoPrincipal)
        errors.push("No hay un diagnostico principal");

      if (this.esCoberturaIESS && !documentoAs400)
        errors.push("Debe ingresar el documento AS400");

      if (!encuestaRealizada) errors.push("Debe ingresar la encuesta");

      // if(!this.stSignature)
      //   errors.push("Debe ingresar la firma del paciente");

      if (!errors.length) return true;

      this.$swal({
        title: "No se puede guardar la atencion",
        html: `<ul style="text-align: left;">${errors
          .map((err) => `<li>${err}</li>`)
          .join("")}</ul>`,
        icon: "error",
        confirmButtonText: "Cerrar",
      });

      errors = [];
      return false;
    },

    async ingresarDerivaciones() {
      if (!this.stAtencionCita?.derivacionesInterconsultas) return;

      const { derivaciones } =
        this.stAtencionCita.derivacionesInterconsultas?.crear;

      if (derivaciones?.length === 0) return;

      derivaciones.forEach(async (d) => {
        const establecimiento = getEstablecimientoLS();
        let nivelDerivacion = null;

        if (["1", "3", "4"].includes(establecimiento.id)) nivelDerivacion = "1";

        if (["2", "5", "6"].includes(establecimiento.id)) nivelDerivacion = "2";

        const params = {
          idAtencion: this.cacm,
          especialidad: d.especialidad?.value,
          tipoAtencion: d.tipoAtencion?.value.toString(),
          cuadroClinico: `${this.stAnamnesis?.problemaActual} ${this.stAnamnesis?.antecedentesPersonales?.text || ""
            }`,
          // fechaDerivacion : getCurrentDate(),
          fechaDerivacion: this.stDataCita.fechaCita,
          diagnosticos: JSON.stringify(this.stAnamnesis?.diagnostico),
          nivelDerivacion: nivelDerivacion,
        };

        const derivacionResponse = await derivacionesService.registrar(params);
        const derivacionObj = {
          ...derivacionResponse,
          especialidad: d.especialidad?.text || d.tipoAtencion?.text,
        };
        this.derivacionesRegistradas.push(derivacionObj);
      });

      this.showModalDerivaciones = true;
    },

    async ingresarInterconsultas() {
      if (!this.stAtencionCita?.derivacionesInterconsultas) return;

      const { interconsultas } =
        this.stAtencionCita?.derivacionesInterconsultas?.crear;

      if (interconsultas?.length === 0) return;

      const cuadroClinico = `${this.stAnamnesis?.problemaActual} ${this.stAnamnesis?.antecedentesPersonales?.text || ""
        }`;

      interconsultas.forEach(async (d) => {
        const params = {
          idAtencion: this.cacm,
          especialidad: d.value,
          fechaInterconsulta: getCurrentDate(),
          cuadroClinico: cuadroClinico,
          planTerapeutico: this.stAnamnesis?.planTratamiento,
          diagnosticos: JSON.stringify(this.stAnamnesis?.diagnostico),
          tipo: "1",
        };
        const data = await interconsultaService.registrar(params);
        if (!data) return;

        const interconsultaObj = { ...data, especialidad: d.text };
        this.interconsultasRegistradas.push(interconsultaObj);
      });

      this.showModalDerivaciones = true;
    },

    async ingresarInterconsultasB() {
      const esInterconsulta = this.stAnamnesis?.esInterconsulta;

      if (!esInterconsulta) return;
      const especialidadDoctor = this.stDataCita?.doctor.especialidad.id;
      const cuadroClinico = `${this.stAnamnesis?.problemaActual} ${this.stAnamnesis?.antecedentesPersonales?.text || ""
        }`;

      const params = {
        idAtencion: this.cacm,
        especialidad: especialidadDoctor,
        cuadroClinico: cuadroClinico,
        fechaInterconsulta: getCurrentDate(),
        planTerapeutico: this.stAnamnesis?.planTratamiento,
        diagnosticos: JSON.stringify(this.stAnamnesis?.diagnostico),
        tipo: "2",
      };

      const data = await interconsultaService.registrar(params);
      if (!data) return;

      const interconsultaObj = { ...data, especialidad: especialidadDoctor };
      this.interconsultasRegistradas.push(interconsultaObj);
      this.showModalDerivaciones = true;
    },

    onCompletarDespues() {
      this.showModalDerivaciones = false;
      this.$router.push({ name: "consultar_citas" });
    },

    onRedirectToDerivacion(derivacionId) {
      this.$router.push({
        name: "derivaciones",
        query: { completar: derivacionId },
      });
    },

    onRedirectToInterconsulta(interconsultaToken) {
      this.$router.push({
        name: "interconsultas",
        query: { completar: interconsultaToken },
      });
    },

    async crearConsultaCitaMedica() {
      const anamitem =
        JSON.parse(localStorage.getItem("crearAnamnesis")) || null;

      let dataSemiologia = this.stDataSemiologia

      const last_odontograma_inicial = await anamnesisService.lastOdontogramaInicial(this.stDataCita.paciente.id)
      this.odontograma_id = last_odontograma_inicial?.id
      if (
        this.stDataSemiologia &&
        this.stDataSemiologia.tipo === "odontologica"
      ) {
        const odontograma_nuevo = await anamnesisService.saveOdontogramaInicial(
          this.idcita,
          this.stDataSemiologia
        );
        if (odontograma_nuevo) {
          this.odontograma_id = odontograma_nuevo?.id;
        }
      }

      if (this.odontograma_id && dataSemiologia) {
        dataSemiologia.data = { ...this.stDataSemiologia.data, odontograma_id: this.odontograma_id }
      }

      dataSemiologia = dataSemiologia
        ? JSON.stringify(dataSemiologia)
        : "";

      if (!anamitem) {
        console.error("no hay datos en ls de crearAnamnesis");
        return null;
      }

      const query = `
        mutation CrearConsultaAtencionCitaMedica(
          $citaId: Int!,  
          $espe: Int, 
          $consulta:Int, 
          $catm: Int, 
          $est: String,
          $signature: String,
          $horainicio: String,
          $semiologia: String
        ) {
          crearConsultaAtencionCitaMedica(
            citaId        : $citaId, 
            tipoEspecialidadId: $espe, 
            tipoConsultaId: $consulta, 
            catmedId      : $catm, 
            estadoRev     : $est,
            signature     : $signature,
            horainicio    : $horainicio,
            semiologia    : $semiologia
          ) {
            status
            consultaCitaMedica {
              id, token
            }
          }
        }
      `;

      const ocurrencia = anamitem.ocurrencia ? anamitem.ocurrencia : 1;
      const horaInicioAtencion = localStorage.getItem("horaInicioAtencion");

      const variables = {
        citaId: parseInt(this.idcita, 10),
        espe: null,
        consulta: parseInt(ocurrencia, 10),
        catm: null,
        est: null,
        signature: this.stSignature,
        horainicio: horaInicioAtencion,
        semiologia: dataSemiologia,
      };

      // Primera mutación GraphQL
      const responseSave = await axios.post(rutas.axios + "api", {
        query,
        variables,
      });

      if (!responseSave) return null;

      const responseSave2 =
        responseSave.data.data.crearConsultaAtencionCitaMedica;
      if (responseSave2.status !== "Success") return null;

      const atencionCreada = responseSave2.consultaCitaMedica;
      this.cacm = atencionCreada.id;
      this.tokenAtencion = atencionCreada.token;

      this.processList.push({ text: "Atencion Creada", value: this.cacm });
      return atencionCreada;
    },

    async fetchGetCita(idCita) {
      const query = `
        query qrgetCitaById($id: String!) {
          getCitaId(idCit: $id) {
            cita {
              id
              token
              fechaCita
              horaCita
              estado
              cobSeleccionada{
                id
                descripcion
              }
              derivacion
              codderivacion
              establecimiento {
                id
                Descripcion
              }
              fecderivacion
              fecfinderivacion
              urlDerivacion
              isInterconsulta
              paciente {
                id
                persona {
                  primerNombre
                  primerApellido
                  identificacion
                  fechaNacimiento
                  sexo
                  residencia {
                    id
                    callePrincipal
                  }
                  nivelEducacion {
                    id
                  }
                  ocupacion {
                    descripcion
                  }
                }
              }
              doctor {
                id
                idPersona {
                  primerNombre
                  primerApellido
                  identificacion
                }
                especialidad {
                  descripcion
                  id
                  codEsp
                }
              }
            }
            status
            message
          }
        }
      `;

      const variables = {
        id: String(idCita),
      };

      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables,
        });

        if (response.status !== 200) return null;

        const dataCita = response.data.data.getCitaId.cita[0];
        this.idPaciente = dataCita?.paciente.id;
        this.tokenCita = dataCita.token;

        localStorage.setItem("idPaciente", this.idPaciente);

        this.dataCita = dataCita;
        this.dataCita.paciente.persona.edad = calculateAgeWithDateString(
          this.dataCita.paciente.persona.fechaNacimiento
        );

        this.$store.commit("setDataCita", this.dataCita);
        console.log("data cita", this.dataCita);

        if (response.data.data.getCitaId.status !== "success") return null;

        if (response.data.data.getCitaId.cita)
          return response.data.data.getCitaId.cita.id;
      } catch (error) {
        console.error("Error fetching doctor:", error);
        return -1;
      }
    },

    resetStateAtencionMedica() {
      this.$store.commit("resetAnamnesis");
      this.$store.commit("resetReceta");
    },

    comprobarPermisos() {
      const permisosUsuario = localStorage.getItem("permisos");
      const requiredPermission = this.$route.meta.requiredPermission;

      if (permisosUsuario.indexOf(requiredPermission) === -1) {
        this.$router.push({ name: "not-permitted" });
      } else {
        console.log("El usuario tiene permiso para acceder a esta ruta.");
      }
    },
  },
};
</script>

<style>
.scrollable-content {
  max-height: 200px;
  overflow-y: auto;
}

.custom-button-color {
  background-color: #3498db;
  border-color: #2980b9;
  color: #ffffff;
}

.custom-button-color:hover {
  background-color: #2980b9;
}
</style>
